export default "__VITE_ASSET__f08f1c40__"